import React, { useState } from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';


function CmsElementImageCompare(props) {
  const { editMode, index, showElementSettings } = props;

  // Local state for the slider position (0-100%)
  const [sliderPos, setSliderPos] = useState(50);

  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    cursor: editMode ? 'move' : 'default',
  };

  const imageUrl = getParamValue('imageUrl', '');
  const compareImageUrl = getParamValue('compareImageUrl', '');
  const isVisible = editMode || shown;

  const handleSliderChange = (e) => {
    // Prevent dragging the CMS element while sliding
    e.stopPropagation();
    setSliderPos(e.target.value);
  };

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-image-compare relative ${isVisible ? 'elem-shown' : 'elem-hidden'} ${cssClasses} ${responsiveClasses}`.trim()}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={getBackgroundStyle()}
    >
      {elementStyleTag}

      {imageUrl && compareImageUrl ? (
        <div
          className="compare-wrapper"
          style={{ position: 'relative', width: '100%', overflow: 'hidden', userSelect: 'none' }}
        >
          {/* Base Image (Nachher / Unten) */}
          <img src={compareImageUrl} style={{ width: '100%', display: 'block', pointerEvents: 'none' }} alt="After" />

          {/* Overlay Image (Vorher / Oben) */}
          <div
            className="compare-overlay"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: `${sliderPos}%`,
              height: '100%',
              overflow: 'hidden',
              borderRight: '2px solid white',
            }}
          >
            <img
              src={imageUrl}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'left center',
                display: 'block',
                maxWidth: 'none', // Important to keep image size stable
              }}
              alt="Before"
              /* We need to ensure the image width matches the container width,
                 even if the parent div is clipped */
              onLoad={(e) => {
                e.target.style.width = e.target.closest('.compare-wrapper').offsetWidth + 'px';
              }}
            />
          </div>

          {/* Invisible Range Slider for Interaction */}
          <input
            type="range"
            min="0"
            max="100"
            value={sliderPos}
            onChange={handleSliderChange}
            onMouseDown={(e) => e.stopPropagation()} // Stop DnD interference
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              opacity: 0,
              cursor: 'col-resize',
              zIndex: 10,
            }}
          />

          {/* Visual Slider Handle Line */}
          <div
            className="compare-handle"
            style={{
              position: 'absolute',
              top: 0,
              left: `${sliderPos}%`,
              bottom: 0,
              width: '4px',
              backgroundColor: 'white',
              marginLeft: '-2px',
              pointerEvents: 'none',
              zIndex: 5,
              boxShadow: '0 0 10px rgba(0,0,0,0.5)',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '40px',
                height: '40px',
                backgroundColor: 'white',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
              }}
            >
              <i className="fa fa-arrows-alt-h" style={{ color: '#333' }} />
            </div>
          </div>
        </div>
      ) : (
        <div className="p-t-30 p-b-30 text-center bg-master-lightest">
          <i className="fa fa-arrows-alt-h fa-4x" />
          <p className="m-t-10">Select two images to compare</p>
        </div>
      )}

      {getAppendHtml()}
    </div>
  );

  const parallaxData = getParallaxData();

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementImageCompare;
